
@if (series) {
    <div
        class="agpr-chartDrilldownSourcePicker"
        [class.agpr-chartDrilldownSourcePicker--hasFilters]="hasActiveFilters && !showFiltersBeside"
        [class.agpr-chartDrilldownSourcePicker--showBackground]="showFiltersBeside"
        role="group"
        [attr.aria-labelledby]="ariaLabelledBy"
    >
        <div
            [class.agpr-chartDrilldownSourcePicker-source]="!showFiltersBeside"
        >
            <div
                class="agpr-chartDrilldownSourcePicker-inputGroup"
            >
                @if (showDateRange && !showDateRangeBelow) {
                    <div class="agpr-chartDrilldownSourcePicker-dateQuery">
                        <agpr-date-query-popup
                            [ariaLabelledBy]="id + '_dateQuery'"
                            [options]="dateOptions"
                            [(ngModel)]="dateQuery"
                            [searchRange]="searchRange"
                            (ngModelChange)="dateRangeChanged()"
                            [id]="id"
                        >
                        </agpr-date-query-popup>
                    </div>
                }
                <agpr-dropdown
                    [id]="id + '-chartDrilldownSourcePickerDropdown'"
                    [options]="typeOptions"
                    ariaLabel="Source.type"
                    [(ngModel)]="selectedType"
                    (ngModelChange)="selectType($event.value)"
                ></agpr-dropdown>
                <div
                    class="agpr-chartDrilldownSourcePicker-autocompleteWrapper"
                    [class.agpr-chartDrilldownSourcePicker-autocompleteWrapper--showFiltersBeside]="showFiltersBeside"
                >
                    <agpr-autocomplete
                        class="agpr-chartDrilldownSourcePicker-autocomplete"
                        [class.agpr-chartDrilldownSourcePicker-autocompleteBorder]="!showFilterButton"
                        [id]="id + '.autocomplete'"
                        [suggestions]="getSuggestions$()"
                        labelField="label"w
                        [placeholder]="'Reports.series.type.' + series?.type + '.placeholder'"
                        [dropdown]="true"
                        [clearOnBlur]="false"
                        [(ngModel)]="selectedOption"
                        (itemSelected)="selectItem($event)"
                        (clear)="selectItem(null)"
                        (focus)="onInputFocus()"
                        (blur)="onInputBlur()"
                        [ariaLabel]="'Reports.series.type.' + series?.type + '.placeholder'"
                        [ariaInvalid]="ariaInvalid ? ariaInvalid : showError"
                        [ariaDescribedBy]="ariaDescribedBy ? ariaDescribedBy : id + '_invalidSourceError'"
                        [showHiddenOption]="showHiddenOption"
                    ></agpr-autocomplete>
                </div>
                @if (showFilterButton) {
                    <div class="agpr-chartDrilldownSourcePicker-filterButton">
                        <agpr-filter-dropdown
                            [id]="id"
                            (filtersApplied)="handleFiltersApplied()"
                        ></agpr-filter-dropdown>
                    </div>
                }
                @if (hasActiveFilters && showFiltersBeside) {
                    <div class="agpr-chartDrilldownSourcePicker-filterChipsBeside">
                        <ng-container *ngTemplateOutlet="filterChips"></ng-container>
                    </div>
                }
            </div>
            @if (hasActiveFilters && !showFiltersBeside) {
                <div class="agpr-chartDrilldownSourcePicker-filterChips">
                    <ng-container *ngTemplateOutlet="filterChips"></ng-container>
                </div>
            }
        </div>

        @if (showDateRange && showDateRangeBelow) {
            <div class="agpr-chartDrilldownSourcePicker-dateQuery--below">
                <agpr-date-query-popup
                    [ariaLabelledBy]="id + '_dateQuery'"
                    [options]="dateOptions"
                    [(ngModel)]="dateQuery"
                    [searchRange]="searchRange"
                    (ngModelChange)="dateRangeChanged()"
                    [id]="id"
                >
                </agpr-date-query-popup>
            </div>
        }
    </div>
}
@if (showError) {
    <agpr-form-message [id]="id + '_invalidSourceError'">
        {{ (!selectedOption ? 'Reports.series.dataSourceRequired' : 'Reports.series.invalidSource') | localize }}
    </agpr-form-message>
}

<ng-template #filterChips>
    <agpr-filter-chips
        [id]="id"
        (chipsRemoved)="handleFiltersApplied()"
    >
    </agpr-filter-chips>
</ng-template>
